
import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { AnimatedSidebarLink } from "@/components/ui/animated-sidebar";

interface SidebarFooterProps {
  open: boolean;
  user: { email?: string | null };
  profile?: { company_name?: string | null };
  onHelpClick: () => void;
  otherLinks: {
    label: string;
    href: string;
    icon: React.ReactNode;
    onClick?: () => void;
  }[];
}

export const SidebarFooter: React.FC<SidebarFooterProps> = ({
  open,
  user,
  profile,
  onHelpClick,
  otherLinks
}) => {
  return (
    <div className="border-t border-gray-800 pt-4 mt-auto">
      <div className="px-2">
        {otherLinks.map((link, idx) => (
          <AnimatedSidebarLink key={`other-${idx}`} link={link} />
        ))}
      </div>
      
      {open && (
        <div className="flex items-center gap-3 mt-6 pt-4 border-t border-gray-800">
          <div className="w-9 h-9 rounded-full bg-jade/20 flex items-center justify-center">
            <span className="font-medium text-jade">
              {user?.email?.substring(0, 1).toUpperCase()}
            </span>
          </div>
          <div className="flex-1 truncate">
            <p className="text-sm font-medium text-white truncate">{user?.email}</p>
            <p className="text-xs text-gray-400 truncate">{profile?.company_name || 'Kein Unternehmen'}</p>
          </div>
          <Tooltip>
            <TooltipTrigger asChild>
              <button onClick={onHelpClick} className="p-1 rounded-full hover:bg-gray-800 text-gray-400">
                <HelpCircle className="h-4 w-4" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="top">
              <p>Hilfe</p>
            </TooltipContent>
          </Tooltip>
        </div>
      )}
    </div>
  );
};
